import angular from 'angular';

import LspPageSubHeaderComponent from './lsp-page-sub-header/lsp-page-sub-header-component';
import SearchComponent from './search/search-component';
import DropdownComponent from './dropdown/dropdown-component';
import CollapseComponent from './collapse/collapse-component';
import ProgressChart from './progress-chart/progress-chart-component';
import capcha from './rw-captcha/rw-captcha-module';
import keybord from './lsp-keyboard/lsp-keyboard-module';
import rest from './rest/rest-module';
import downloadElement from './download-element/download-element-module';
import lspGrid from './lsp-grid/lsp-grid-module';
import grid from './grid/grid-module';
import image from './lsp-image/lsp-image-module';
import bulletPlaceholder from './lsp-bullet-placeholder/lsp-bullet-placeholder-module';
import footerBar from './footer-bar/footer-bar-module';
import carousel from './carousel/carousel-module.ts';
import rwTooltipModule from './rw-tooltip/rw-tooltip-module';
import multiLanguage from './multilanguage/multilanguage-module';
import fileUpload from './file-upload/file-upload-module';
import filePreview from './file-preview/file-preview-module';
import dirtyForm from './dirty-form/dirty-form-directive';
import CancelButtonComponent from './dirty-form/cancel-button-component';
import rwClearField from './rw-clear-field/rw-clear-field-module';
import rwRequiredOneOf from './rw-required-one-of/rw-required-one-of-module';
import fileCard from './file-card/file-card-module';
import rwCard from './rw-card/rw-card-module';
import rwGamePosterModule from './rw-game-poster/rw-game-poster-module';
import rwDateModule from './rw-date/rw-date-module';
import rwCurrencyModule from './rw-currency/rw-currency-module';
import rwRetailerIdModule from './rw-retailer-id/rw-retailer-id-module';
import rwPhoneModule from './rw-phone/rw-phone-module';
import rwUserClassModule from './rw-user-class/rw-user-class-module';
import rwCopyrightModule from './rw-copyright/rw-copyright-module';
import rwAppVersionModule from './rw-app-version/rw-app-version-module';
import rwPrivacyPolicyModule from './rw-privacy-policy/rw-privacy-policy-module';
import rwTermsOfUseModule from './rw-terms-of-use/rw-terms-of-use-module';
import rwHomepageLinksModule from './rw-homepage-links/rw-homepage-links-module';
import rwButtonModule from './rw-button/rw-button-module';
import rwTrackingNumber from './rw-tracking-number/rw-tracking-number-module';
import rwIconModule from './rw-icon/rw-icon-module';
import rwActionsDropdownModule from './rw-actions-dropdown/rw-actions-dropdown-module';
import rwSocialMediaModule from './rw-social-media/rw-social-media-module';
import rwMultistoreSelectorModule from './rw-multistore-selector/rw-multistore-selector-module';
import rwRetailerInfoModule from './rw-retailer-info/rw-retailer-info-module';
import rwSubordinatesModule from './rw-subordinates/rw-subordinates-module';
import rwListModule from './rw-list/rw-list-module';
import rwDatepickerModule from './rw-datepicker/rw-datepicker-module';
import rwTimepickerModule from './rw-timepicker/rw-timepicker-module';
import rwEditorModule from './rw-editor/rw-editor-module';
import rwLocationSelectorModule from './rw-location-selector/rw-location-selector-module';
import rwBoxModule from './rw-box/rw-box-module';
import filters from './lsp-filters/lsp-filters-module';
import validators from './lsp-validators/lsp-validators-module';
import utils from './lsp-utils-service';
import LspAlertService from './lsp-alerts/lsp-alert-service';
import ResponsiveService from './responsive/responsive-service';
import DirtyFormService from './dirty-form/cancel-service';
import WidgetService from './widget/widget-service';
import emailVariablesCkeditorPlugin from './editor/email-variables-ckeditor-plugin';
import tabComponent from './tab/tab-component';
import notifications from './notifications/notifications';
import './save-as-polyfill';

const lsUtilsRun = (gettextCatalog) => {
  // Ckeditor plugin initialization
  emailVariablesCkeditorPlugin(gettextCatalog);
};

lsUtilsRun.$inject = ['gettextCatalog'];

export default angular
  .module('utils', [
    // prettier-ignore
    capcha.name,
    filters.name,
    validators.name,
    keybord.name,
    rest.name,
    downloadElement.name,
    lspGrid.name,
    grid.name,
    image.name,
    bulletPlaceholder.name,
    footerBar.name,
    carousel.name,
    rwTooltipModule.name,
    multiLanguage.name,
    tabComponent.name,
    notifications.name,
    fileUpload.name,
    filePreview.name,
    dirtyForm.name,
    rwClearField.name,
    rwRequiredOneOf.name,
    fileCard.name,
    rwCard.name,
    rwGamePosterModule.name,
    rwDateModule.name,
    rwCurrencyModule.name,
    rwRetailerIdModule.name,
    rwPhoneModule.name,
    rwUserClassModule.name,
    rwCopyrightModule.name,
    rwAppVersionModule.name,
    rwPrivacyPolicyModule.name,
    rwTermsOfUseModule.name,
    rwHomepageLinksModule.name,
    rwButtonModule.name,
    rwTrackingNumber.name,
    rwIconModule.name,
    rwActionsDropdownModule.name,
    rwSocialMediaModule.name,
    rwMultistoreSelectorModule.name,
    rwRetailerInfoModule.name,
    rwSubordinatesModule.name,
    rwListModule.name,
    rwDatepickerModule.name,
    rwTimepickerModule.name,
    rwEditorModule.name,
    rwLocationSelectorModule.name,
    rwBoxModule.name,
  ])
  .run(lsUtilsRun)
  .component('lspPageSubHeader', new LspPageSubHeaderComponent())
  .component('search', new SearchComponent())
  .component('dropdown', new DropdownComponent())
  .component('collapse', new CollapseComponent())
  .component('progressChart', new ProgressChart())
  .component('cancelButton', new CancelButtonComponent())
  .service('AlertService', LspAlertService)
  .service('Responsive', ResponsiveService)
  .service('DirtyForm', DirtyFormService)
  .service('widgetService', WidgetService)
  .service('utils', utils);



// WEBPACK FOOTER //
// ./src/modules/utils/utils-component.js